module.exports = __webpack_public_path__ + "static/media/feat-hero.2066d0c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/feat-hero.png
// module id = 1248
// module chunks = 0